import { useI18n } from "~/i18n";
import { LOCALES } from "~/i18n";

interface LanguageSwitcherProps {
  variant?: "default" | "hero";
  forceColor?: string;
}

export function LanguageSwitcher({ variant = "default", forceColor }: LanguageSwitcherProps) {
  const { locale, setLocale } = useI18n();

  const isHero = variant === "hero";
  const activeClassName = isHero ? "text-white" : "text-[var(--ip-primary)]";
  const inactiveClassName = isHero
    ? "text-white/50 hover:text-white"
    : "text-[var(--ip-text-muted)] hover:text-[var(--ip-text)]";
  const dividerClassName = isHero
    ? "text-[rgba(255,255,255,0.25)]"
    : "text-[rgba(var(--ip-primary-glow),0.18)]";

  return (
    <div className="header__lang flex items-center gap-2">
      {LOCALES.map((loc, i) => (
        <span key={loc.value} className="flex items-center gap-2">
          {i > 0 && (
            <span
              className={`header__lang-divider text-[12px] leading-[1.7] ${dividerClassName}`}
              style={forceColor ? { color: forceColor, opacity: 0.3 } : undefined}
            >
              |
            </span>
          )}
          <button
            className={`header__lang-btn text-[11px] font-medium tracking-[0.15em] transition-colors ${
              locale === loc.value ? `active ${activeClassName}` : inactiveClassName
            }`}
            style={
              forceColor
                ? { color: forceColor, opacity: locale === loc.value ? 1 : 0.5 }
                : undefined
            }
            onClick={() => setLocale(loc.value)}
          >
            {loc.label}
          </button>
        </span>
      ))}
    </div>
  );
}
